import { render } from "./AdministratorDetail.vue?vue&type=template&id=204161ae&scoped=true"
import script from "./AdministratorDetail.vue?vue&type=script&lang=js"
export * from "./AdministratorDetail.vue?vue&type=script&lang=js"

import "./AdministratorDetail.vue?vue&type=style&index=0&id=204161ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204161ae"]])

export default __exports__